import React from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { TitleDescriptionIncidentForm } from '../components/TitleDescriptionIncidentForm';

export const PaymentsQuestionForm = ({
  customTranslations,
}: ParsedEntry<IWidget>) => (
  <TitleDescriptionIncidentForm
    incidentKind="PaymentsQuestion"
    classifications={{
      classification: IncidentClassification.RENTALPAYMENT_STATUS,
      subClassification: IncidentSubClassification.QUESTION_FOR_PAYMENT,
    }}
    translations={customTranslations}
    withFileUpload
  />
);
